<div class="mx-3 d-flex justify-content-between align-items-center">
  <span class="modal-title m-r-5">
    <h4 class="text-decoration-underline" tmwTranslate="anc.habilitation.title">Gestion des Habilitations</h4>
    <span class="f-s-14 f-w-700 text-muted">{{ habilitationParams.ressourceCode }}</span>
  </span>
  <button type="button" class="btn-close" data-dismiss="modal" aria-hidden="true" (click)="cancel()"></button>
</div>

@if(roles?.length) {
    <tmw-multi-select-edit
        [list]="roles"
        id="roleAssignment"
        name="roleAssignment"
        [changeAssignment]="false"
        keyField="id"
        labelFiled="libelle"
        [enableFilter]="true"
        [isSaving]="isSaving"
        [(ngModel)]="roleIds"
        (assigned)="onRolesAssigned($event)"
        (unassigned)="onRolesUnassigned($event)">
    </tmw-multi-select-edit>
}
